import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { orgActions } from "../../actions";
import { userActions } from "../../actions";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { OrgDropdown } from "../org/OrgDropdown";
import { DEBUG_STATE } from "../../constants/constants.js"

function UserCreate(props) {
  const { authentication, org, users, getDocTypes, createUser, getAllRoles } = props;


  const creator = authentication?.user;
  const creatorOrgList = creator?.orgs;

  const cancelicon = require("../../images/status-red.png").default;
  const saveicon = require("../../images/status-green.png").default;

  const roles = users?.roles;

  const assignable_orgs = authentication?.user?.orgs;

  const [restrict_ip, setRestrict_ip] = useState(false);

  const [docTypeList, setDocTypeList] = useState([]);
  const [ip1, setIp1] = useState('');
  const [ip2, setIp2] = useState('');
  const [ip3, setIp3] = useState('');
  const [use_mfa, setUse_mfa] = useState(true);
  const [mfa_type, setMfa_type] = useState("sms");
  const [roleList, setRoleList] = useState([]);
  const [orgList, setOrgList] = useState([Number(authentication?.user?.org_id)]);
  const [userRequest, setUserRequest] = useState({});
  const [userOrgId, setUserOrgId] = useState(Number(authentication?.user?.org_id))
  const [creatorOrgId, setCreatorOrgId] = useState(Number(authentication?.user?.org_id));
  const [allowDocTypes, setAllowDocTypes] = useState(authentication?.user?.use_doctypes);


  const doctypes = org?.doc_types;
  const debug = DEBUG_STATE;


  useEffect(() => {
    if (userOrgId) {
      getDocTypes(userOrgId);
    }

  }, [userOrgId])

  useEffect(() => {
    getAllRoles();
  }, [])

  const handleChangeRestrictIp = () => {
    setRestrict_ip(!restrict_ip);
  };

  const handleChangeUseMfa = () => {

    const old_use_mfa = use_mfa;

    setUse_mfa(!use_mfa);
    if (old_use_mfa) {
      setMfa_type("none")
    }
    else {
      setMfa_type("sms");
    }
  };

  const onChangeMfaType = (e) => {
    const newValue = e.target.value;
    userRequest["mfa_type"] = newValue;
    setMfa_type(newValue);
  }

  const setUserOrg = (event) => {
    const numericOrgId = Number(event.target.value);
    var oldUserOrg = userOrgId;

    setUserOrgId(numericOrgId);

    let newOrgList = orgList.filter((org_id) => (Number(org_id) !== Number(oldUserOrg)));
    newOrgList.push(numericOrgId);
    setOrgList(newOrgList);


    setAllowDocTypes(creatorOrgList.find(o => o.org_id == numericOrgId).allow_doc_types);
    console.log(userRequest);
  };

  const setFirstName = (e) => {
    const { name, value } = e.target;
    userRequest["first_name"] = value;
  };

  const setLastName = (e) => {
    const { name, value } = e.target;
    userRequest["last_name"] = value;
  };

  const setEmail = (e) => {
    const { name, value } = e.target;
    userRequest["email"] = value;
  };

  const setPhone = (e) => {
    const { name, value } = e.target;
    userRequest["phone"] = value;
  };

  const handleChangeIp1 = (e) => {
    setIp1(e.target.value);
  }

  const handleChangeIp2 = (e) => {
    setIp2(e.target.value);
  }

  const handleChangeIp3 = (e) => {
    setIp3(e.target.value);
  }

  function removeOrg(id) {
    const newOrgList = orgList.filter((org_id) => (Number(org_id) !== Number(id)));
    setOrgList(newOrgList);
  }


  function addOrg(id) {
    const newOrgList = orgList.slice();
    newOrgList.push(Number(id));
    setOrgList(newOrgList);
  }

  const handleChangeOrg = (e) => {
    if (e.target.checked) {
      addOrg(e.target.value);
    } else {
      removeOrg(e.target.value);
    }
  }

  function addRole(role) {
    roleList.push(role);
  }

  function removeRole(role_to_delete) {
    const newRoleList = roleList.filter((role) => (role !== role_to_delete));
    setRoleList(newRoleList);
  }

  const handleChangeRole = (e) => {
    if (e.target.checked) {
      addRole(e.target.value);
    } else {
      removeRole(e.target.value);
    }
  }


  /*const removeOrg = (id) => { 
    setOrgList(orgList.filter((org_id) => org_id !== id));
  };*/

  const handleSubmit = (event) => {
    event.preventDefault();

    if (userRequest["mfa_type"] === "sms") {
      if (!userRequest["phone"]) {
        // throw some error
      }
    }

    userRequest["org_id"] = userOrgId;
    userRequest["doctypes"] = docTypeList;
    userRequest["restrict_ip"] = restrict_ip;
    if (!use_mfa) {
      userRequest["mfa_type"] = "none";
    } else {
      userRequest["mfa_type"] = mfa_type;
    }
    userRequest["orgs"] = orgList;
    userRequest["roles"] = roleList;
    if (!restrict_ip) {
      userRequest["restricted_ips"] = ['*'];
    } else {
      userRequest["restricted_ips"] = [ip1, ip2, ip3];
    }

    if (debug) {
      console.log(creator);
      console.log(orgList);
      console.log(roleList);
      console.log(userRequest);
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    createUser(userRequest);

  };

  const handleDocTypeChange = (event) => {

    if (docTypeList.includes(event.target.value)) {
      const newList = docTypeList.filter(type =>
        type !== event.target.value);
      setDocTypeList(newList);
      if (debug) {
        console.log(newList);
        console.log(docTypeList);
      }
    } else {
      const newList = [event.target.value, ...docTypeList];
      setDocTypeList(newList);
      if (debug) {
        console.log(newList);
        console.log(docTypeList);
      }

    }
  };

  const user_roles_html = roles?.map((role, i) => (
    <>
      <tr key={"role-" + i}>
        <td className="formLabel">
          {role.name}
        </td>
        <td className="formInfo">
          {
            (roleList?.includes(role.name)) && (
              <input type="checkbox" checked value={role.name} onChange={handleChangeRole} />
            )
          }
          {
            (!(roleList?.includes(role.name))) && (
              <input type="checkbox" value={role.name} onChange={handleChangeRole} />
            )
          }
        </td>
      </tr>
    </>
  ));

  const user_orgs_html = assignable_orgs?.map((org, i) => (
    <>
      <tr key={"org-" + i}>
        <td className="formLabel">
          {org.display_name}
        </td>
        <td className="formInfo">
          {
            (orgList?.includes(org.org_id)) && (
              <input type="checkbox" checked name="userOrg" value={org.org_id} onChange={handleChangeOrg} />
            )
          }
          {
            (!(orgList?.includes(org.org_id))) && (
              <input type="checkbox" name="userOrg" value={org.org_id} onChange={handleChangeOrg} />
            )
          }
        </td>
      </tr>
    </>
  ));


  const doctypes_html = doctypes?.map((doctype, i) => (
    <tr>
      <td className="formLabel">{doctype.doc_type_name}</td>
      <td className="formInfo">
        {
          docTypeList?.includes(doctype.doc_type_name) &&
          (<input type="checkbox" name="doc_type" value={doctype.doc_type_name} checked="checked" onChange={handleDocTypeChange} />)
        }
        {
          !(docTypeList?.includes(doctype.doc_type_name)) && (<input type="checkbox" name="doc_type" value={doctype.doc_type} onChange={handleDocTypeChange} />)
        }
      </td>
    </tr>
  ));


  return (
    <div class="searchMain">
      <div class="contentContainerLeftNav">
        <div class="rightContent">
          <h3>
            create new user
            &nbsp;&nbsp;&nbsp;
            <span className="h3SubSpan">(creating)</span>
            &nbsp;&nbsp;&nbsp;
            <div className="editJacketNameIcon" onClick="" data-tip data-for="cancel">
              <Link
                to={{
                  pathname: "/users/"

                }}
              >
                <img src={cancelicon} className="cancelImage" width="20px" alt="cancel" />
              </Link>
            </div>
            &nbsp;&nbsp;&nbsp;
            <ReactTooltip id="cancel" place="bottom" effect="solid" data-type="info" delayShow={200}>
              cancel
            </ReactTooltip>
            <div className="editJacketNameIcon" onClick="" data-tip data-for="save" >
              <img src={saveicon} className="saveImage" width="20px" alt="save" onClick={handleSubmit} />
            </div>
            <ReactTooltip id="save" place="bottom" effect="solid" data-type="info" delayShow={200}>
              save
            </ReactTooltip>
          </h3>
          <div class="orgDetailTile">
            <div className="orgDetailTileHeader">
              Contact
            </div>
            <table class="ingestorFormTable">
              <tr>
                <td class="formLabel">Primary Org:</td>
                <td class="formInfo">
                  <OrgDropdown handler={setUserOrg} prepop={userOrgId} />
                </td>
              </tr>
              <tr>
                <td class="formLabel">first name</td>
                <td class="formInfo">
                  <input
                    style={{ width: "100%" }}
                    id="first_name"
                    name="first_name"
                    type="text"
                    onChange={setFirstName}
                  />
                </td>
              </tr>
              <tr>
                <td class="formLabel">last name</td>
                <td class="formInfo">
                  <input
                    style={{ width: "100%" }}
                    id="last_name"
                    name="last_name"
                    type="text"
                    onChange={setLastName}
                  />
                </td>
              </tr>
              <tr>
                <td class="formLabel">email</td>
                <td class="formInfo">
                  <input
                    style={{ width: "100%" }}
                    id="email"
                    name="email"
                    type="text"
                    onChange={setEmail}
                  />
                </td>
              </tr>
              <tr>
                <td class="formLabel">phone</td>
                <td class="formInfo">
                  <input
                    id="phone"
                    name="phone"
                    type="text"
                    onChange={setPhone}
                  />
                </td>
              </tr>

            </table>
          </div>

          <div class="orgDetailTile">
            <div className="orgDetailTileHeader">
              Access
            </div>
            <table class="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">restrict ip?</td>
                  <td className="formInfo">
                    {
                      restrict_ip && (<input type="checkbox" checked onChange={handleChangeRestrictIp} />)
                    }
                    {
                      !(restrict_ip) && (<input type="checkbox" onChange={handleChangeRestrictIp} />)
                    }
                  </td>
                </tr>

                {restrict_ip && (
                  <>
                    <tr>
                      <td className="formLabel">ip address 1</td>
                      <td className="formInfo">
                        <input
                          style={{ width: "100%" }}
                          id="ip_address"
                          name="ip_address"
                          autoComplete="off"
                          onChange={handleChangeIp1}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="formLabel">ip address 2:</td>
                      <td class="formInfo">
                        <input
                          style={{ width: "100%" }}
                          id="ip_address2"
                          name="ip_address2"
                          autoComplete="off"
                          onChange={handleChangeIp2}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="formLabel">ip address 3:</td>
                      <td class="formInfo">
                        <input
                          style={{ width: "100%" }}
                          id="ip_address3"
                          name="ip_address3"
                          autoComplete="off"
                          onChange={handleChangeIp3}
                        />
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Multi-Factor Authentication (MFA)
            </div>
            <table class="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Use MFA?</td>
                  <td className="formInfo">
                    {
                      (use_mfa) && (<input type="checkbox" checked onChange={handleChangeUseMfa} />)
                    }
                    {
                      (!use_mfa) && (<input type="checkbox" onChange={handleChangeUseMfa} />)
                    }
                  </td>
                </tr>
                {use_mfa && (
                  <>
                    <tr>
                      <td className="formLabel">Mfa Type</td>
                      <td className="formInto">
                        <select
                          className="orgDropdown"
                          value={mfa_type}
                          onChange={(e) => onChangeMfaType(e)}
                        >
                          <option key="none" id="none" name="none" value="none">
                            Select an MFA Type
                          </option>
                          <option key={"sms"} id="sms" name="sms" value="sms">
                            sms
                          </option>
                          <option key={"email"} id="email" name="email" value="email">
                            email
                          </option>
                        </select>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>


          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Orgs
            </div>
            <table class="ingestorFormTable">
              <tbody>
                {user_orgs_html}
              </tbody>
            </table>
          </div>


          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Roles
            </div>
            <table class="ingestorFormTable">
              <tbody>
                {user_roles_html}
              </tbody>
            </table>
          </div>


          <div class="orgDetailTile">
            <div className="orgDetailTileHeader">
              Doc Types
            </div>
            <table class="ingestorFormTable">
              {allowDocTypes && (
                <tbody>
                  {doctypes_html}
                </tbody>
              )}
              {!allowDocTypes && (
                <tbody>
                  <tr>
                    <td colSpan="1">
                      <span className="tileInfoText">
                        Document Type Permissioning not enabled for the selected Primary Org.
                      </span>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>

        </div>

      </div >

      <br />

    </div >


  );
}

function mapStateToProps(state) {
  const { authentication, org, users } = state;
  return {
    authentication,
    org,
    users
  };
}

const actionCreators = {
  getDocTypes: orgActions.getDocTypes,
  getUserDetail: userActions.getUserDetail,
  getAllRoles: userActions.getAllRoles,
  createUser: userActions.createUser
};

const connectedUserCreate = connect(mapStateToProps, actionCreators)(UserCreate);
export { connectedUserCreate as UserCreate };
